<div class="work-packages-split-view--tabletimeline-content" style=" margin-top: 30px;" *ngIf="teamList">
  
  <div class="work-packages-tabletimeline--table-side work-package-table--container __hidden_overflow_container">
<div class="activity_one activity" style="box-shadow: 0px 2px 4px rgb( 0 0 0 / 8%)" [ngClass]="{'droDown': oneShow}"> 
  <div class="header" (click)="dropDown(1)">
    <div class="title">
      {{teamList.activity_one.team_name}}
    </div>
    <div class="Statistics">
        <span>Activities: {{teamList.activity_one.count}};</span>
        <span>Labour/People: {{teamList.activity_one.labour_number}};</span>
        <span>Plant/Equipment:{{teamList.activity_one.plant_working + '/' +teamList.activity_one.plant_ldle}};</span>
    </div>
    <div class="dropDown" >
      >
    </div>
  </div>
  <div class="addButton" *ngIf="oneShow">
    <button class="addActivty icon-add" *ngIf="divClick=='activity' && permissionBtn()" (click)="copyClick(1)">Copy From</button>
    <button class="addActivty icon-add" *ngIf="divClick=='activity' && permissionBtn()" (click)="addActivtyClick(1)">Add</button>
  </div>  <table style=" margin: 0 auto;" class="keyboard-accessible-list generic-table work-package-table" *ngIf="oneShow">
    <thead class="-sticky">
      <tr style="border-bottom: 1px solid #E7E7E7;"  class="listTitle">
        <th>Section</th>
        <th>Portion</th>
        <th>Location</th>
          <th>Activity</th>
          <th>Labour/People</th>
          <th>Plant/Equipment</th>
     
        <th>Actions</th>
      </tr>
    </thead>
    <tbody class="results-tbody work-package--results-tbody" *ngFor="let item of tableList1">  
      <tr>
        <td>{{item.section_name}}</td>
        <td>{{item.protion_name}}</td>
        <td>{{item.location}}</td>
          <td class="activity">{{item.activity}}</td>
          <td>
            <div class="labur_plant">
              {{item.labur_number}}.0
              <div class="labur_plant-item">
                <span *ngFor="let laburItem of item.labours">({{laburItem.number}})&nbsp;&nbsp;{{laburItem.labour_name}}&nbsp;&nbsp;{{laburItem.ownership}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="labur_plant">
              {{item.plant_working}}.0/{{item.plant_ldle}}.0
              <div class="labur_plant-item">
                <span *ngFor="let laburItem of item.plants">({{laburItem.working}}/{{laburItem.ldle}})&nbsp;&nbsp;{{laburItem.equipment}}&nbsp;&nbsp;{{laburItem.plant_mark}}&nbsp;&nbsp;{{laburItem.ldle_code[0]}}&nbsp;&nbsp;{{laburItem.ownership}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="tablebutton" *ngIf="!isEdit">
              <div (click)="editClick(item,1)" style="background-color: #777777;">Edit</div>
              <div (click)="deleteClick(item, 1)" style="background-color: #e15353;">Delete</div>
            </div>
            <div class="tablebutton" *ngIf="isEdit">
              <div (click)="editClick(item,1)" style="background-color: #00a7ec">View</div>
            </div>
          </td>

  
      </tr>
    </tbody>
  </table>

</div>
<div class="activity_two activity" style="box-shadow: 0px 2px 4px rgb( 0 0 0 / 8%)" [ngClass]="{'droDown': twoShow}">
  <div class="header" (click)="dropDown(2)">
    <div class="title">
      {{teamList.activity_two.team_name}}
    </div>
    <div class="Statistics">
        <span>Activities: {{teamList.activity_two.count}};</span>
        <span>Labour/People: {{teamList.activity_two.labour_number}};</span>
        <span>Plant/Equipment:{{teamList.activity_two.plant_working + '/' +teamList.activity_two.plant_ldle}};</span>
    </div>
    <div class="dropDown" >
      >
    </div>
  </div>
  <div class="addButton" *ngIf="twoShow">
    <button class="addActivty icon-add" *ngIf="divClick=='activity' && permissionBtn()" (click)="copyClick(2)">Copy From</button>
    <button class="addActivty icon-add" *ngIf="divClick=='activity' && permissionBtn()" (click)="addActivtyClick(2)">Add</button>
  </div>
  <table style=" margin: 0 auto;" class="keyboard-accessible-list generic-table work-package-table" *ngIf="twoShow">
    <thead class="-sticky">
      <tr style="border-bottom: 1px solid #E7E7E7;"  class="listTitle">
        <th>Section</th>
        <th>Portion</th>
        <th>Location</th>
          <th>Activity</th>
          <th>Labour/People</th>
          <th>Plant/Equipment</th>
   
        <th>Actions</th>
      </tr>
    </thead>
    <tbody class="results-tbody work-package--results-tbody" *ngFor="let item of tableList2">  
      <tr>
        <td>{{item.section_name}}</td>
        <td>{{item.protion_name}}</td>
        <td>{{item.location}}</td>
        <ng-container *ngIf="divClick == 'activity'">
          <td class="activity">{{item.activity}}</td>
          <td>
            <div class="labur_plant">
              {{item.labur_number}}.0
              <div class="labur_plant-item">
                <span *ngFor="let laburItem of item.labours">({{laburItem.number}})&nbsp;&nbsp;{{laburItem.labour_name}}&nbsp;&nbsp;{{laburItem.ownership}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="labur_plant">
              {{item.plant_working}}.0/{{item.plant_ldle}}.0
              <div class="labur_plant-item">
                <span *ngFor="let laburItem of item.plants">({{laburItem.working}}/{{laburItem.ldle}})&nbsp;&nbsp;{{laburItem.equipment}}&nbsp;&nbsp;{{laburItem.plant_mark}}&nbsp;&nbsp;{{laburItem.ldle_code[0]}}&nbsp;&nbsp;{{laburItem.ownership}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="tablebutton" *ngIf="!isEdit">
              <div (click)="editClick(item,2)" style="background-color: #777777;">Edit</div>
              <div (click)="deleteClick(item,2)" style="background-color: #e15353;">Delete</div>
            </div>
            <div class="tablebutton" *ngIf="isEdit">
              <div (click)="editClick(item,2)" style="background-color: #00a7ec">View</div>
            </div>
          </td>
        </ng-container>
  
      </tr>
    </tbody>
  </table>

</div>
<div class="activity_three activity" style="box-shadow: 0px 2px 4px rgb( 0 0 0 / 8%)" [ngClass]="{'droDown': threeShow}">
  <div class="header" (click)="dropDown(3)">
    <div class="title">
      {{teamList.activity_three.team_name}}
    </div>
    <div class="Statistics">
        <span>Activities: {{teamList.activity_three.count}};</span>
        <span>Labour/People: {{teamList.activity_three.labour_number}};</span>
        <span>Plant/Equipment:{{teamList.activity_three.plant_working + '/' +teamList.activity_three.plant_ldle}}</span>
    </div>
    <div class="dropDown" >
      >
    </div>
  </div>
  <div class="addButton" *ngIf="threeShow">
    <button class="addActivty icon-add" *ngIf="divClick=='activity' && permissionBtn()" (click)="copyClick(3)">Copy From</button>
    <button class="addActivty icon-add" *ngIf="divClick=='activity' && permissionBtn()" (click)="addActivtyClick(3)">Add</button>
  </div>
  <table style=" margin: 0 auto;" class="keyboard-accessible-list generic-table work-package-table" *ngIf="threeShow">
    <thead class="-sticky">
      <tr style="border-bottom: 1px solid #E7E7E7;"  class="listTitle">
        <th>Section</th>
        <th>Portion</th>
        <th>Location</th>
          <th>Activity</th>
          <th>Labour/People</th>
          <th>Plant/Equipment</th>
   
        <th>Actions</th>
      </tr>
    </thead>
    <tbody class="results-tbody work-package--results-tbody" *ngFor="let item of tableList3">  
      <tr>
        <td>{{item.section_name}}</td>
        <td>{{item.protion_name}}</td>
        <td>{{item.location}}</td>
        <ng-container *ngIf="divClick == 'activity'">
          <td class="activity">{{item.activity}}</td>
          <td>
            <div class="labur_plant">
              {{item.labur_number}}.0
              <div class="labur_plant-item">
                <span *ngFor="let laburItem of item.labours">({{laburItem.number}})&nbsp;&nbsp;{{laburItem.labour_name}}&nbsp;&nbsp;{{laburItem.ownership}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="labur_plant">
              {{item.plant_working}}.0/{{item.plant_ldle}}.0
              <div class="labur_plant-item">
                <span *ngFor="let laburItem of item.plants">({{laburItem.working}}/{{laburItem.ldle}})&nbsp;&nbsp;{{laburItem.equipment}}&nbsp;&nbsp;{{laburItem.plant_mark}}&nbsp;&nbsp;{{laburItem.ldle_code[0]}}&nbsp;&nbsp;{{laburItem.ownership}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="tablebutton" *ngIf="!isEdit">
              <div (click)="editClick(item,3)" style="background-color: #777777;">Edit</div>
              <div (click)="deleteClick(item,3)" style="background-color: #e15353;">Delete</div>
            </div>
            <div class="tablebutton" *ngIf="isEdit">
              <div (click)="editClick(item,3)" style="background-color: #00a7ec">View</div>
            </div>
          </td>
        </ng-container>
  
      </tr>
    </tbody>
  </table>
</div> 
<div class="activity_four activity" style="box-shadow: 0px 2px 4px rgb( 0 0 0 / 8%)" [ngClass]="{'droDown': fourShow}">
  <div class="header" (click)="dropDown(4)">
    <div class="title">
      {{teamList.activity_four.team_name}}
    </div>
    <div class="Statistics">
        <span>Activities: {{teamList.activity_four.count}};</span>
        <span>Labour/People: {{teamList.activity_four.labour_number}};</span>
        <span>Plant/Equipment:{{teamList.activity_four.plant_working + '/' +teamList.activity_four.plant_ldle}};</span>
    </div>
    <div class="dropDown" >
      >
    </div>
  </div>
  <div class="addButton" *ngIf="fourShow">
    <button class="addActivty icon-add" *ngIf="divClick=='activity' && permissionBtn()" (click)="copyClick(4)">Copy From</button>
    <button class="addActivty icon-add" *ngIf="divClick=='activity' && permissionBtn()" (click)="addActivtyClick(4)">Add</button>
  </div>


  <table style=" margin: 0 auto;" class="keyboard-accessible-list generic-table work-package-table" *ngIf="fourShow">
    <thead class="-sticky">
      <tr style="border-bottom: 1px solid #E7E7E7;"  class="listTitle">
        <th>Section</th>
        <th>Portion</th>
        <th>Location</th>
          <th>Activity</th>
          <th>Labour/People</th>
          <th>Plant/Equipment</th>
   
        <th>Actions</th>
      </tr>
    </thead>
    <tbody class="results-tbody work-package--results-tbody" *ngFor="let item of tableList4">  
      <tr>
        <td>{{item.section_name}}</td>
        <td>{{item.protion_name}}</td>
        <td>{{item.location}}</td>
        <ng-container *ngIf="divClick == 'activity'">
          <td class="activity">{{item.activity}}</td>
          <td>
            <div class="labur_plant">
              {{item.labur_number}}.0
              <div class="labur_plant-item">
                <span *ngFor="let laburItem of item.labours">({{laburItem.number}})&nbsp;&nbsp;{{laburItem.labour_name}}&nbsp;&nbsp;{{laburItem.ownership}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="labur_plant">
              {{item.plant_working}}.0/{{item.plant_ldle}}.0
              <div class="labur_plant-item">
                <span *ngFor="let laburItem of item.plants">({{laburItem.working}}/{{laburItem.ldle}})&nbsp;&nbsp;{{laburItem.equipment}}&nbsp;&nbsp;{{laburItem.plant_mark}}&nbsp;&nbsp;{{laburItem.ldle_code[0]}}&nbsp;&nbsp;{{laburItem.ownership}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="tablebutton" *ngIf="!isEdit">
              <div (click)="editClick(item,4)" style="background-color: #777777;">Edit</div>
              <div (click)="deleteClick(item,4)" style="background-color: #e15353;">Delete</div>
            </div>
            <div class="tablebutton" *ngIf="isEdit">
              <div (click)="editClick(item,4)" style="background-color: #00a7ec">View</div>
            </div>
          </td>
        </ng-container>
  
      </tr>
    </tbody>
  </table>
</div>
<div class="activity_five activity" style="box-shadow: 0px 2px 4px rgb( 0 0 0 / 8%)" [ngClass]="{'droDown': fiveShow}">
  <div class="header" (click)="dropDown(5)">
    <div class="title">
      {{teamList.activity_five.team_name}}
    </div>
    <div class="Statistics">
        <span>Activities: {{teamList.activity_five.count}};</span>
        <span>Labour/People: {{teamList.activity_five.labour_number}};</span>
        <span>Plant/Equipment:{{teamList.activity_five.plant_working + '/' +teamList.activity_five.plant_ldle}};</span>
    </div>
    <div class="dropDown" >
      >
    </div>
  </div>
  <div class="addButton" *ngIf="fiveShow">
    <button class="addActivty icon-add" *ngIf="divClick=='activity' && permissionBtn()" (click)="copyClick(5)">Copy From</button>
    <button class="addActivty icon-add" *ngIf="divClick=='activity' && permissionBtn()" (click)="addActivtyClick(5)">Add</button>
  </div>


  <table style=" margin: 0 auto;" class="keyboard-accessible-list generic-table work-package-table" *ngIf="fiveShow">
    <thead class="-sticky">
      <tr style="border-bottom: 1px solid #E7E7E7;"  class="listTitle">
        <th>Section</th>
        <th>Portion</th>
        <th>Location</th>
          <th>Activity</th>
          <th>Labour/People</th>
          <th>Plant/Equipment</th>
   
        <th>Actions</th>
      </tr>
    </thead>
    <tbody class="results-tbody work-package--results-tbody" *ngFor="let item of tableList5">  
      <tr>
        <td>{{item.section_name}}</td>
        <td>{{item.protion_name}}</td>
        <td>{{item.location}}</td>
        <ng-container *ngIf="divClick == 'activity'">
          <td class="activity">{{item.activity}}</td>
          <td>
            <div class="labur_plant">
              {{item.labur_number}}.0
              <div class="labur_plant-item">
                <span *ngFor="let laburItem of item.labours">({{laburItem.number}})&nbsp;&nbsp;{{laburItem.labour_name}}&nbsp;&nbsp;{{laburItem.ownership}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="labur_plant">
              {{item.plant_working}}.0/{{item.plant_ldle}}.0
              <div class="labur_plant-item">
                <span *ngFor="let laburItem of item.plants">({{laburItem.working}}/{{laburItem.ldle}})&nbsp;&nbsp;{{laburItem.equipment}}&nbsp;&nbsp;{{laburItem.plant_mark}}&nbsp;&nbsp;{{laburItem.ldle_code[0]}}&nbsp;&nbsp;{{laburItem.ownership}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="tablebutton" *ngIf="!isEdit">
              <div (click)="editClick(item,5)" style="background-color: #777777;">Edit</div>
              <div (click)="deleteClick(item,5)" style="background-color: #e15353;">Delete</div>
            </div>
            <div class="tablebutton" *ngIf="isEdit">
              <div (click)="editClick(item,5)" style="background-color: #00a7ec">View</div>
            </div>
          </td>
        </ng-container>
  
      </tr>
    </tbody>
  </table>
</div>
<div class="activity_six activity" style="box-shadow: 0px 2px 4px rgb( 0 0 0 / 8%)" [ngClass]="{'droDown': sixShow}">
  <div class="header" (click)="dropDown(6)">
    <div class="title">
      {{teamList.activity_six.team_name}}
    </div>
    <div class="Statistics">
        <span>Activities: {{teamList.activity_six.count}};</span>
        <span>Labour/People: {{teamList.activity_six.labour_number}};</span>
        <span>Plant/Equipment:{{teamList.activity_six.plant_working + '/' +teamList.activity_six.plant_ldle}};</span>
    </div>
    <div class="dropDown" >
      >
    </div>
  </div>
  <div class="addButton" *ngIf="sixShow">
    <button class="addActivty icon-add" *ngIf="divClick=='activity' && permissionBtn()" (click)="copyClick(6)">Copy From</button>
    <button class="addActivty icon-add" *ngIf="divClick=='activity' && permissionBtn()" (click)="addActivtyClick(6)">Add</button>
  </div>


  <table style=" margin: 0 auto;" class="keyboard-accessible-list generic-table work-package-table" *ngIf="sixShow">
    <thead class="-sticky">
      <tr style="border-bottom: 1px solid #E7E7E7;"  class="listTitle">
        <th>Section</th>
        <th>Portion</th>
        <th>Location</th>
          <th>Activity</th>
          <th>Labour/People</th>
          <th>Plant/Equipment</th>
   
        <th>Actions</th>
      </tr>
    </thead>
    <tbody class="results-tbody work-package--results-tbody" *ngFor="let item of tableList6">  
      <tr>
        <td>{{item.section_name}}</td>
        <td>{{item.protion_name}}</td>
        <td>{{item.location}}</td>
        <ng-container *ngIf="divClick == 'activity'">
          <td class="activity">{{item.activity}}</td>
          <td>
            <div class="labur_plant">
              {{item.labur_number}}.0
              <div class="labur_plant-item">
                <span *ngFor="let laburItem of item.labours">({{laburItem.number}})&nbsp;&nbsp;{{laburItem.labour_name}}&nbsp;&nbsp;{{laburItem.ownership}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="labur_plant">
              {{item.plant_working}}.0/{{item.plant_ldle}}.0
              <div class="labur_plant-item">
                <span *ngFor="let laburItem of item.plants">({{laburItem.working}}/{{laburItem.ldle}})&nbsp;&nbsp;{{laburItem.equipment}}&nbsp;&nbsp;{{laburItem.plant_mark}}&nbsp;&nbsp;{{laburItem.ldle_code[0]}}&nbsp;&nbsp;{{laburItem.ownership}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="tablebutton" *ngIf="!isEdit">
              <div (click)="editClick(item,6)" style="background-color: #777777;">Edit</div>
              <div (click)="deleteClick(item,6)" style="background-color: #e15353;">Delete</div>
            </div>
            <div class="tablebutton" *ngIf="isEdit">
              <div (click)="editClick(item,6)" style="background-color: #00a7ec">View</div>
            </div>
          </td>
        </ng-container>
  
      </tr>
    </tbody>
  </table>
</div>
<div class="activity_seven activity" style="box-shadow: 0px 2px 4px rgb( 0 0 0 / 8%)" [ngClass]="{'droDown': sevenShow}">
  <div class="header" (click)="dropDown(7)">
    <div class="title">
      {{teamList.activity_seven.team_name}}
    </div>
    <div class="Statistics">
        <span>Activities: {{teamList.activity_seven.count}};</span>
        <span>Labour/People: {{teamList.activity_seven.labour_number}};</span>
        <span>Plant/Equipment:{{teamList.activity_seven.plant_working + '/' +teamList.activity_seven.plant_ldle}};</span>
    </div>
    <div class="dropDown" >
      >
    </div>
  </div>
  <div class="addButton" *ngIf="sevenShow">
    <button class="addActivty icon-add" *ngIf="divClick=='activity' && permissionBtn()" (click)="copyClick(7)">Copy From</button>
    <button class="addActivty icon-add" *ngIf="divClick=='activity' && permissionBtn()" (click)="addActivtyClick(7)">Add</button>
  </div>


  <table style=" margin: 0 auto;" class="keyboard-accessible-list generic-table work-package-table" *ngIf="sevenShow">
    <thead class="-sticky">
      <tr style="border-bottom: 1px solid #E7E7E7;"  class="listTitle">
        <th>Section</th>
        <th>Portion</th>
        <th>Location</th>
          <th>Activity</th>
          <th>Labour/People</th>
          <th>Plant/Equipment</th>
   
        <th>Actions</th>
      </tr>
    </thead>
    <tbody class="results-tbody work-package--results-tbody" *ngFor="let item of tableList7">  
      <tr>
        <td>{{item.section_name}}</td>
        <td>{{item.protion_name}}</td>
        <td>{{item.location}}</td>
        <ng-container *ngIf="divClick == 'activity'">
          <td class="activity">{{item.activity}}</td>
          <td>
            <div class="labur_plant">
              {{item.labur_number}}.0
              <div class="labur_plant-item">
                <span *ngFor="let laburItem of item.labours">({{laburItem.number}})&nbsp;&nbsp;{{laburItem.labour_name}}&nbsp;&nbsp;{{laburItem.ownership}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="labur_plant">
              {{item.plant_working}}.0/{{item.plant_ldle}}.0
              <div class="labur_plant-item">
                <span *ngFor="let laburItem of item.plants">({{laburItem.working}}/{{laburItem.ldle}})&nbsp;&nbsp;{{laburItem.equipment}}&nbsp;&nbsp;{{laburItem.plant_mark}}&nbsp;&nbsp;{{laburItem.ldle_code[0]}}&nbsp;&nbsp;{{laburItem.ownership}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="tablebutton" *ngIf="!isEdit">
              <div (click)="editClick(item,7)" style="background-color: #777777;">Edit</div>
              <div (click)="deleteClick(item,7)" style="background-color: #e15353;">Delete</div>
            </div>
            <div class="tablebutton" *ngIf="isEdit">
              <div (click)="editClick(item,7)" style="background-color: #00a7ec">View</div>
            </div>
          </td>
        </ng-container>
  
      </tr>
    </tbody>
  </table>
</div>
<div class="activity_eight activity" style="box-shadow: 0px 2px 4px rgb( 0 0 0 / 8%)" [ngClass]="{'droDown': eightShow}">
  <div class="header" (click)="dropDown(8)">
    <div class="title">
      {{teamList.activity_eight.team_name}}
    </div>
    <div class="Statistics">
        <span>Activities: {{teamList.activity_eight.count}};</span>
        <span>Labour/People: {{teamList.activity_eight.labour_number}};</span>
        <span>Plant/Equipment:{{teamList.activity_eight.plant_working + '/' +teamList.activity_eight.plant_ldle}};</span>
    </div>
    <div class="dropDown" >
      >
    </div>
  </div>
  <div class="addButton" *ngIf="eightShow">
    <button class="addActivty icon-add" *ngIf="divClick=='activity' && permissionBtn()" (click)="copyClick(8)">Copy From</button>
    <button class="addActivty icon-add" *ngIf="divClick=='activity' && permissionBtn()" (click)="addActivtyClick(8)">Add</button>
  </div>


  <table style=" margin: 0 auto;" class="keyboard-accessible-list generic-table work-package-table" *ngIf="eightShow">
    <thead class="-sticky">
      <tr style="border-bottom: 1px solid #E7E7E7;"  class="listTitle">
        <th>Section</th>
        <th>Portion</th>
        <th>Location</th>
          <th>Activity</th>
          <th>Labour/People</th>
          <th>Plant/Equipment</th>
   
        <th>Actions</th>
      </tr>
    </thead>
    <tbody class="results-tbody work-package--results-tbody" *ngFor="let item of tableList8">  
      <tr>
        <td>{{item.section_name}}</td>
        <td>{{item.protion_name}}</td>
        <td>{{item.location}}</td>
        <ng-container *ngIf="divClick == 'activity'">
          <td class="activity">{{item.activity}}</td>
          <td>
            <div class="labur_plant">
              {{item.labur_number}}.0
              <div class="labur_plant-item">
                <span *ngFor="let laburItem of item.labours">({{laburItem.number}})&nbsp;&nbsp;{{laburItem.labour_name}}&nbsp;&nbsp;{{laburItem.ownership}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="labur_plant">
              {{item.plant_working}}.0/{{item.plant_ldle}}.0
              <div class="labur_plant-item">
                <span *ngFor="let laburItem of item.plants">({{laburItem.working}}/{{laburItem.ldle}})&nbsp;&nbsp;{{laburItem.equipment}}&nbsp;&nbsp;{{laburItem.plant_mark}}&nbsp;&nbsp;{{laburItem.ldle_code[0]}}&nbsp;&nbsp;{{laburItem.ownership}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="tablebutton" *ngIf="!isEdit">
              <div (click)="editClick(item,8)" style="background-color: #777777;">Edit</div>
              <div (click)="deleteClick(item,8)" style="background-color: #e15353;">Delete</div>
            </div>
            <div class="tablebutton" *ngIf="isEdit">
              <div (click)="editClick(item,8)" style="background-color: #00a7ec">View</div>
            </div>
          </td>
        </ng-container>
  
      </tr>
    </tbody>
  </table>
</div>
<div class="activity_nine activity" style="box-shadow: 0px 2px 4px rgb( 0 0 0 / 8%)" [ngClass]="{'droDown': nineShow}">
  <div class="header" (click)="dropDown(9)">
    <div class="title">
      {{teamList.activity_nine.team_name}}
    </div>
    <div class="Statistics">
        <span>Activities: {{teamList.activity_nine.count}};</span>
        <span>Labour/People: {{teamList.activity_nine.labour_number}};</span>
        <span>Plant/Equipment:{{teamList.activity_nine.plant_working + '/' +teamList.activity_nine.plant_ldle}};</span>
    </div>
    <div class="dropDown" >
      >
    </div>
  </div>
  <div class="addButton" *ngIf="nineShow">
    <button class="addActivty icon-add" *ngIf="divClick=='activity' && permissionBtn()" (click)="copyClick(9)">Copy From</button>
    <button class="addActivty icon-add" *ngIf="divClick=='activity' && permissionBtn()" (click)="addActivtyClick(9)">Add</button>
  </div>


  <table style=" margin: 0 auto;" class="keyboard-accessible-list generic-table work-package-table" *ngIf="nineShow">
    <thead class="-sticky">
      <tr style="border-bottom: 1px solid #E7E7E7;"  class="listTitle">
        <th>Section</th>
        <th>Portion</th>
        <th>Location</th>
          <th>Activity</th>
          <th>Labour/People</th>
          <th>Plant/Equipment</th>
   
        <th>Actions</th>
      </tr>
    </thead>
    <tbody class="results-tbody work-package--results-tbody" *ngFor="let item of tableList9">  
      <tr>
        <td>{{item.section_name}}</td>
        <td>{{item.protion_name}}</td>
        <td>{{item.location}}</td>
        <ng-container *ngIf="divClick == 'activity'">
          <td class="activity">{{item.activity}}</td>
          <td>
            <div class="labur_plant">
              {{item.labur_number}}.0
              <div class="labur_plant-item">
                <span *ngFor="let laburItem of item.labours">({{laburItem.number}})&nbsp;&nbsp;{{laburItem.labour_name}}&nbsp;&nbsp;{{laburItem.ownership}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="labur_plant">
              {{item.plant_working}}.0/{{item.plant_ldle}}.0
              <div class="labur_plant-item">
                <span *ngFor="let laburItem of item.plants">({{laburItem.working}}/{{laburItem.ldle}})&nbsp;&nbsp;{{laburItem.equipment}}&nbsp;&nbsp;{{laburItem.plant_mark}}&nbsp;&nbsp;{{laburItem.ldle_code[0]}}&nbsp;&nbsp;{{laburItem.ownership}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="tablebutton" *ngIf="!isEdit">
              <div (click)="editClick(item,9)" style="background-color: #777777;">Edit</div>
              <div (click)="deleteClick(item,9)" style="background-color: #e15353;">Delete</div>
            </div>
            <div class="tablebutton" *ngIf="isEdit">
              <div (click)="editClick(item,9)" style="background-color: #00a7ec">View</div>
            </div>
          </td>
        </ng-container>
  
      </tr>
    </tbody>
  </table>
</div>
<div class="activity_ten activity" style="box-shadow: 0px 2px 4px rgb( 0 0 0 / 8%)" [ngClass]="{'droDown': tenShow}">
  <div class="header" (click)="dropDown(10)">
    <div class="title">
      {{teamList.activity_ten.team_name}}
    </div>
    <div class="Statistics">
        <span>Activities: {{teamList.activity_ten.count}};</span>
        <span>Labour/People: {{teamList.activity_ten.labour_number}};</span>
        <span>Plant/Equipment:{{teamList.activity_ten.plant_working + '/' +teamList.activity_ten.plant_ldle}};</span>
    </div>
    <div class="dropDown" >
      >
    </div>
  </div>
  <div class="addButton" *ngIf="tenShow">
    <button class="addActivty icon-add" *ngIf="divClick=='activity' && permissionBtn()" (click)="copyClick(10)">Copy From</button>
    <button class="addActivty icon-add" *ngIf="divClick=='activity' && permissionBtn()" (click)="addActivtyClick(10)">Add</button>
  </div>


  <table style=" margin: 0 auto;" class="keyboard-accessible-list generic-table work-package-table" *ngIf="tenShow">
    <thead class="-sticky">
      <tr style="border-bottom: 1px solid #E7E7E7;"  class="listTitle">
        <th>Section</th>
        <th>Portion</th>
        <th>Location</th>
          <th>Activity</th>
          <th>Labour/People</th>
          <th>Plant/Equipment</th>
   
        <th>Actions</th>
      </tr>
    </thead>
    <tbody class="results-tbody work-package--results-tbody" *ngFor="let item of tableList10">  
      <tr>
        <td>{{item.section_name}}</td>
        <td>{{item.protion_name}}</td>
        <td>{{item.location}}</td>
        <ng-container *ngIf="divClick == 'activity'">
          <td class="activity">{{item.activity}}</td>
          <td>
            <div class="labur_plant">
              {{item.labur_number}}.0
              <div class="labur_plant-item">
                <span *ngFor="let laburItem of item.labours">({{laburItem.number}})&nbsp;&nbsp;{{laburItem.labour_name}}&nbsp;&nbsp;{{laburItem.ownership}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="labur_plant">
              {{item.plant_working}}.0/{{item.plant_ldle}}.0
              <div class="labur_plant-item">
                <span *ngFor="let laburItem of item.plants">({{laburItem.working}}/{{laburItem.ldle}})&nbsp;&nbsp;{{laburItem.equipment}}&nbsp;&nbsp;{{laburItem.plant_mark}}&nbsp;&nbsp;{{laburItem.ldle_code[0]}}&nbsp;&nbsp;{{laburItem.ownership}}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="tablebutton" *ngIf="!isEdit">
              <div (click)="editClick(item,10)" style="background-color: #777777;">Edit</div>
              <div (click)="deleteClick(item,10)" style="background-color: #e15353;">Delete</div>
            </div>
            <div class="tablebutton" *ngIf="isEdit">
              <div (click)="editClick(item,10)" style="background-color: #00a7ec">View</div>
            </div>
          </td>
        </ng-container>
  
      </tr>
    </tbody>
  </table>
</div>
  </div>
</div>

<!-- modulelist 分页 -->
<!-- <ng-container >
  <div class="pagination" style="position: absolute; bottom: 10px;">
    <ul class="pagination--items">
      <li class="pagination--item" *ngIf="modulepage-1 != 0"><a href="" (click)='modulego("prev")' id="pagination--prev-link" rel="prev start" role="link" aria-label="Back to the previous page">&lt;</a></li>
      <li *ngFor="let item of modulesize;let i = index" class="pagination--item pagination-number" ng-reflect-klass="pagination--item pagination-nu" ng-reflect-ng-class="[object Object]">
        <a [ngClass]="{peracss:modulepage==i+1}" (click)='modulelistpage(i+1)' href="" rel="next" role="link">{{i+1}}</a></li>
      <li class="pagination--item" *ngIf="modulepage != modulesize.length"><a (click)='modulego("next")' class="pagination--next-link" href="" id="pagination--next-link" rel="next" role="link" aria-label="Forward to the next page">&gt;</a></li>
    </ul>
  </div>
</ng-container> -->
<SiteDiary-Details-addActivity [teamIndex]="editIndex" [isEdit]="isEdit" [summaryData]="summaryData" [updataActivty]="updataActivty" (close)="addActivtyClick()" *ngIf="addActivty"></SiteDiary-Details-addActivity>
<div class="wage" *ngIf="copyShow"></div>
<div class="activeCopy" *ngIf="copyShow">
  <div class="case">
    <div class="Close" (click)="closeCopy()">X</div>
    <div class="filter">
      <div class="title">
        <span>Site Diary Date:</span><span id="activetyCopyDate">dataTimeText</span>
      </div>
      <div class="team">
        <span>Team:</span>
        <select [(ngModel)]="filterName" (change)="changeTeam()">
          <option *ngFor="let item of copyTeamList" [value]="item.id">{{item.name}}</option>
        </select>
      </div>
    </div>
 

    <div class="CopyAll"><span>Copy All:</span> <input [(ngModel)]="copyCheckAll" type="checkbox" (click)="checkAll()"/></div>
    <div class="table">
      <table style=" margin: 0 auto;" class="keyboard-accessible-list generic-table work-package-table">
        <thead class="-sticky">
          <tr style="border-bottom: 1px solid #E7E7E7;"  class="listTitle">
            <th>Copy</th>
            <th>Team</th>
            <th>Section</th>
            <th>Portion</th>
            <th>Location</th>
            <th>Activity</th>
            <th>Labour/People</th>
            <th>Plant/Equipment</th>
          </tr>
        </thead>
        <tbody class="results-tbody work-package--results-tbody" *ngFor="let item of copyList">  
          <tr>
            <td><input [(ngModel)]="item.copy" type="checkbox"/></td>
            <td>{{item.team_name}}</td>
            <td>{{item.section_name}}</td>
            <td>{{item.protion_name}}</td>
            <td>{{item.location}}</td>
              <td class="activity">{{item.activity}}</td>
              <td>
                <div class="labur_plant">
                  {{item.labur_number}}.0
                  <div class="labur_plant-item">
                    <span *ngFor="let laburItem of item.labours">({{laburItem.number}})&nbsp;&nbsp;{{laburItem.labour_name}}&nbsp;&nbsp;{{laburItem.ownership}}</span>
                  </div>
                </div>
              </td>
              <td>
                <div class="labur_plant">
                  {{item.plant_working}}.0/{{item.plant_ldle}}.0
                  <div class="labur_plant-item">
                    <span *ngFor="let laburItem of item.plants">({{laburItem.working}}/{{laburItem.ldle}})&nbsp;&nbsp;{{laburItem.equipment}}&nbsp;&nbsp;{{laburItem.plant_mark}}&nbsp;&nbsp;{{laburItem.ldle_code[0]}}&nbsp;&nbsp;{{laburItem.ownership}}</span>
                  </div>
                </div>
              </td>
     
  
          </tr>
        </tbody>
      </table>
    </div>
    <div class="action">
      <div class="submit" (click)="copySubmit()">Submmit</div>
      <div class="Cancel" (click)="closeCopy()">Cancel</div>
    </div>
  </div>
</div>